export default "__VITE_ASSET__6fc22aed__"